import { prop, theme } from '@lib/style/theme';
import { classNames } from '@lib/utils';
import MenuItem from '@material-ui/core/MenuItem';
import { font } from '@packages/style/fonts';
import React from 'react';
import styled from 'styled-components';

const bulletBackground = (props) => prop('color', 'dark', (c) => theme(`colors.${c}`, c)(props))(props);

/**
 * @author: Dumitrana Alinus <alin.designstudio@gmail.com>
 * @class: BulletItem
 * @date:  21.09.2018
 * @time:  14:15
 * @scope:
 */
export const Bullet = styled(({ color, ...props }) => <span {...props} />)`
    position: relative;
    display: inline-block;
    z-index: 3;
    border: none !important;
    border-radius: 4px;
    width: 8px;
    height: 8px;
    margin: 8px;
    background-color: ${bulletBackground};
`;

export const BulletText = styled(({ color, children, className, ...props }) => (
    <span {...props} className={classNames('ui--bullet__text', className)}>
        <Bullet color={color} />
        {children}
    </span>
))`
    & {
        display: flex;
        align-items: center;
        align-content: center;
        justify-content: flex-start;
        color: #333;
        ${font(14)}
    }
`;

export const BulletItem = styled(({ color, children, ...props }) => (
    <MenuItem {...props}>
        <BulletText color={color}>{children}</BulletText>
    </MenuItem>
))`
    && {
        padding: 6px 12px 6px 4px;
    }
`;
